class AlertEvents {

    constructor() {
        this.addListeners = [];
        this.removeListeners = [];
        this.clearListeners = [];
    }

    clear() {
        this.clearListeners.forEach(cb => cb());
    }
    add(alert) {
        this.addListeners.forEach(cb => cb(alert));
        return alert;
    }

    remove(alert) {
        this.removeListeners.forEach(cb => cb(alert));
        return alert;
    }

    onAdd(cb) {
        this.addListeners.push(cb);
    }

    onRemove(cb) {
        this.removeListeners.push(cb)
    }

    onClear(cb) {
        this.clearListeners.push(cb);
    }
}

export default AlertEvents;